import coloStatsPlot from "../../../../content/posts/data-release-notes/colo_2023.05/colo_stats.jsx";
import * as React from 'react';
export default {
  coloStatsPlot,
  React
};